module.exports = __webpack_public_path__ + "static/20231219_Change_in_Management_HSE-35ba89307007c3ff8391254f1907e0b9.pdf";